import { required } from "react-admin";

const alphaNumericRegex = /^[a-zA-Z0-9]*$/;
const alphaNumeric = (message = 'Must be an alphanumeric string without spaces') =>
      value => value && alphaNumericRegex.exec(value) ? undefined : message;
const length = max => value =>
  value && value.length !== max ? `Must have ${max} alphanumeric characters` : undefined
export const validatePsc = [required(), length(5), alphaNumeric()];
